import { Item } from '@/src/ct-design/lib/Dropdown/type'
import { VisaOption } from '@/src/types/visa/visaRequirementsType'

export const entryTypeMap = {
    SINGLE_ENTRY: 'Single Entry',
    MULTI_ENTRY: 'Multi Entry'
}
export const getVisaTypeString = (visaOption: VisaOption) => {
    const { days, entryType } = visaOption
    return `${days} days ${entryTypeMap[entryType] ? `- ${entryTypeMap[entryType]}` : ''}`
}

export const getDisplayValue = (value: string, list: Item[]) => {
    if (!value) return ''
    return list.find((item) => item.key === value)?.item || value
}

export const getItineraryIdFromPath = (pathname: string) => {
    const path = pathname
    const itineraryPrefix = 'itinerary/'
    const startIndex = path.indexOf(itineraryPrefix)

    if (startIndex === -1) {
        return null
    }

    const idStartIndex = startIndex + itineraryPrefix.length
    const remainingPath = path.substring(idStartIndex)

    const nextSlashIndex = remainingPath.indexOf('/')
    return nextSlashIndex === -1
        ? remainingPath
        : remainingPath.substring(0, nextSlashIndex)
}
export const formatStatusText = (status: string): string => {
    if (!status) return 'In Progress'
    const formatted = status
        .toLowerCase()
        .replace(/[_-]/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase())
    return formatted
}
